import { useTranslation } from 'react-i18next';
import { SsoSignupForm } from '@/modules/auth/components/sso-signup/sso-signup-form';
import { LOGIN_COLORS } from '@/modules/auth/constants/login-theme';
import { Link, Navigate, useSearchParams } from 'react-router-dom';

export const SsoSignupPage = () => {
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();
  const email = searchParams.get('email') ?? '';
  const provider = searchParams.get('provider') ?? '';

  if (!email || !provider) return <Navigate to="/login" replace />;

  return (
    <div className="flex w-full flex-col gap-6">
      <div className="flex flex-col gap-1.5">
        <h2
          className="text-[2rem] font-bold leading-tight tracking-tight sm:text-[2.125rem]"
          style={{ color: LOGIN_COLORS.textPrimary }}
        >
          {t('COMPLETE_SIGNUP')}
        </h2>
        <div className="flex items-center gap-1">
          <span className="text-sm font-normal leading-5" style={{ color: LOGIN_COLORS.textMuted }}>
            {t('ALREADY_HAVE_ACCOUNT')}
          </span>
          <Link
            to="/login"
            className="text-sm font-semibold leading-5 hover:underline"
            style={{ color: LOGIN_COLORS.primary }}
          >
            {t('LOG_IN')}
          </Link>
        </div>
      </div>
      <SsoSignupForm email={email} provider={provider} />
    </div>
  );
};
